import axios, {AxiosInstance, AxiosRequestConfig} from 'axios';
import {ConfigService} from '../Config/ConfigService';

interface ApiServiceInterface {
  get: ApiServiceMethod;
  post: ApiServiceMethod;
  patch: ApiServiceMethod;
  put: ApiServiceMethod;
  delete: ApiServiceMethod;
}

type ApiServiceMethod<T = any, D = any> = (url: string, data: D) => Promise<T>;

type ApiRequestDataType = {};

export class ApiService implements ApiServiceInterface {
  constructor(private configService: ConfigService) {}

  private get axios(): AxiosInstance {
    const options: AxiosRequestConfig = {
      baseURL: this.configService.apiUrl,
    };

    return axios.create(options);
  }

  async get<T = any, D extends ApiRequestDataType = {}>(url: string, body?: D): Promise<T> {
    const {data} = await this.axios.get<T>(url, {
      data: body,
    });

    return data;
  }

  async post<T = any, D extends ApiRequestDataType = {}>(url: string, body?: D): Promise<T> {
    const {data} = await this.axios.post<T>(url, body);

    return data;
  }

  async patch<T = any, D extends ApiRequestDataType = {}>(url: string, body?: D): Promise<T> {
    const {data} = await this.axios.patch<T>(url, body);

    return data;
  }

  async put<T = any, D extends ApiRequestDataType = {}>(url: string, body?: D): Promise<T> {
    const {data} = await this.axios.put<T>(url, body);

    return data;
  }

  async delete<T = any>(url: string): Promise<T> {
    const {data} = await this.axios.delete<T>(url);

    return data;
  }
}
